import React from "react";
import moment from "moment";
import "../../../../Utils/Css/Menu.css";
const fmt = require("indian-number-format");

export default function TradeCard({ item, userType }) {
  const openUserEditor = (type) => {
    if (!item) return;
    switch (type) {
      case "super":
        window.user_id = item.super_id;
        window.openeditSuper?.();
        break;
      case "master":
        window.user_id = item.master_id;
        window.masterModalOpen?.();
        break;
      case "user":
        window.user_id = item.user_id;
        window.userModalOpen?.();
        break;
      default:
        break;
    }
  };

  // ===========================
  //        FORMATTERS
  // ===========================
  const formatExchange = (type) => {
    const map = {
      nse: "NSE",
      mcx: "MCX",
      mcx_options: "MCX-OPTIONS",
      fo: "NSE-OPTIONS",
      nse_cash: "NSE-EQUITY",
      comex_future: "COMEX",
      crypto_future: "CRYPTO",
      forex_future: "FOREX",
      sgx: "SGX",
      us_stock: "US-STOCK",
      index: "OTHERS",
      dgcx: "DGCX",
      ncdex: "NCDEX",
    };
    return map[type?.toLowerCase()] || "NSE";
  };

  const formatNumber = (num, fixed = 0) =>
    fmt.format(parseFloat(num || 0).toFixed(fixed));

  // ===========================
  //      CSS HELPERS
  // ===========================
  const getTypeClass = (type) =>
    type === "NEW" ? "primarytext" : type === "ADDED" ? "buytext" : "selltext";

  const getPLClass = (value) => (value > 0 ? "buytext" : "selltext");

  return (
    <div
      className={`menuContainer addHight text `}
      style={{
        borderWidth: 0,
        borderBottomWidth: 1,
        borderColor: item.watch === 1 ? "#D32F2F" : null ,
      }}
    >
      {/* Exchange */}
      <div className={`menuExchange uppercase small`}>
        {formatExchange(item.script_type)}
      </div>

      {/* ---------- ROLE COLUMNS ---------- */}
      {userType === 1 && (
        <div
          onClick={() => openUserEditor("super")}
          className={`menuExchange uppercase pointer small`}
        >
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      {(userType === 1 || userType === 2) && (
        <div
          onClick={() => openUserEditor("master")}
          className={`menuExchange uppercase pointer small `}
        >
          <div className="user_id">{item.master_username}</div>
        </div>
      )}

      {(userType === 1 ||
        userType === 2 ||
        userType === 3 ||
        userType === 5 ||
        userType === 6) && (
        <div
          onClick={() => openUserEditor("user")}
          className={`menuExchange uppercase pointer small `}
        >
          <div className="user_id">{item.username}</div>
        </div>
      )}

      {/* Symbol */}
      <div className={`menuSymbol small`}>{item.symbol}</div>

      {/* Expiry */}
      <div className={`menuExpiry small`}>
        {item.script_type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM")}
      </div>

      {/* Qty / Rate / Side */}
      <div className={`menuBuyPrice `}>{item.qty}</div>

      <div className={`menuBuyQty `}>
        {item.type === "NEW" || item.type === "ADDED"
          ? "--"
          : item.standing_rate}
      </div>

      <div className={`menuBuyQty `}>{item.rate}</div>

      <div
        className={`menuSellQty ${
          item.buy_sell === 0 ? "buytext" : "selltext"
        } `}
      >
        {item.buy_sell === 0 ? "BUY" : "SELL"}
      </div>

      {/* Balance & Volume */}
      <div className={`menuSellQty small `}>
        {formatNumber(item.new_deposit, 2)}
      </div>

      <div className={`menuSellQty small `}>{formatNumber(item.amount)}</div>

      {/* Type */}
      <div className={`menuSymbol small ${getTypeClass(item.type)} `}>
        {item.type}
      </div>

      {/* Commission */}
      <div className={`menuSellQty small selltext `}>
        {formatNumber(item.brokerage_user_amt, 2)}
      </div>

      {/* P/L */}
      <div className={`menuOpen small ${getPLClass(item.profit_loss)} `}>
        {formatNumber(item.profit_loss, 2)}
      </div>

      {/* Other Info */}
      <div className={`menuLtt extraSmall `}>{item.other ?? "-"}</div>

      {/* Date + Time */}
      <div className={`menuLtt flex flex-col items-center justify-center `}>
        <div className="extraSmall">
          {moment(item.date_created).format("DD-MM-YYYY")}
        </div>
        <div className="small">
          {moment(item.date_created).format("HH:mm:ss")}
        </div>
      </div>

      {/* Duration */}
      <div className={`menuLtt small `}>{item.trade_duration_minutes}</div>
    </div>
  );
}
